export const apiMethods = [
    {
        name: 'Winners',
        method: '/monopoly/winnersdata.php',
        action: 'get',
        postBuild: (postingData, requestObj) => {
            return requestObj;
        },
        postRequest: (err, res) => {},
        args: [
            {
                name: 'game_id',
                processArgs: val => {
                    return val;
                },
            },
            {
                name: 'draw_number',
                processArgs: val => {
                    return val;
                },
            },
        ],
    },
    {
        name: 'GetCsrf',
        method: '/monopoly/feedback.php',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'Feedback',
        method: '/monopoly/feedback.php',
        action: 'post',
        postBuild: (postingData, requestObj) => {
            return requestObj;
        },
        postRequest: (err, res) => {},
        args: [
            {
                name: 'name',
                processArgs: val => val,
            },
            {
                name: 'email',
                processArgs: val => val,
            },
            {
                name: 'comments',
                processArgs: val => val,
            },
            {
                name: 'csrf_token',
                processArgs: val => val,
            },
            {
                name: 'submit',
                processArgs: val => 'Submit',
            },
            {
                name: 'form_submitted',
                processArgs: val => 1,
            },
        ],
    },
    {
        name: 'GetGame',
        method: '/monopoly/game/game.php',
        action: 'get',
        postBuild: (postingData, requestObj) => {
            return requestObj;
        },
        postRequest: (err, res) => {},
        args: [
            {
                name: 'prizelevel',
                processArgs: val => {
                    return val;
                },
            },
            {
                name: 'rolling_amount',
                processArgs: val => {
                    return val;
                },
            },
            {
                name: 'increment',
                processArgs: val => {
                    return val;
                },
            },
            {
                name: 'velocity',
                processArgs: val => {
                    return val;
                },
            },
        ],
    },
    {
        name: 'GetGameOver',
        method: '/monopoly/gameover.php',
        action: 'get',
        postBuild: (postingData, requestObj) => {
            return requestObj;
        },
        postRequest: (err, res) => {},
        args: [],
    },
];
